import { Component, inject, OnInit } from '@angular/core';
import { FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { LandingPageService } from '../../../services/landing-page.service';
import { formMessage } from '../../../interfaces/landing-page.interface';
import { ModalRequisitionResultComponent } from '../../../components/modal-requisition-result/modal-requisition-result.component';

@Component({
  selector: 'app-message-form',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    CommonModule,
    NgxMaskDirective,
  ],
  providers: [
    provideNgxMask()
  ],
  templateUrl: './message-form.component.html',
  styleUrl: './message-form.component.scss'
})
export class MessageFormComponent implements OnInit {
  fb = inject(FormBuilder);
  dialogRef = inject(MatDialogRef);
  dialog = inject(MatDialog);
  landingPageService = inject(LandingPageService);
  data = inject(MAT_DIALOG_DATA);

  messageForm = this.fb.group({
    name: ['', Validators.required],
    email: ['', Validators.email],
    numberPhone: ['', Validators.required],
    solicitation: ['']
  });

  ngOnInit(): void {
    this.messageForm.patchValue({
      solicitation: this.data.solicitation
    });
  }

  sendMessage(): void {
    if (this.messageForm.valid) {
      const formValue = this.messageForm.value;
      const message: formMessage = {
        name: formValue.name || '',
        email: formValue.email || '',
        numberPhone: formValue.numberPhone || '',
        solicitation: formValue.solicitation || ''
      };

      this.landingPageService.sendMessage(message).subscribe((response: any) => {
        this.dialog.open(ModalRequisitionResultComponent, {
          data: {
            modalType: 'success',
            message: 'Solicitação feita com sucesso!',
            boldText: false,
            doubleButton: false,
          }
        })
        this.closeModal();
      },
        (error: Error) => {
          this.dialog.open(ModalRequisitionResultComponent, {
            data: {
              modalType: 'error',
              message: 'Erro ao fazer solicitação. Tente novamente mais tarde.',
              boldText: false,
              doubleButton: false,
            }
          })
        }
      );
    } else {
      this.dialog.open(ModalRequisitionResultComponent, {
        data: {
          modalType: 'error',
          message: 'Preencha todos os campos!',
          boldText: false,
          doubleButton: false,
        }
      });
    }
  }

  closeModal(): void {
    this.dialogRef.close();
  }
}